// apps/frontend_fl/src/services/suporte/auth/fornecedores_listas/index.ts
import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../..";
import StorageItems from "../../../storage";
import { generateMessageReturn } from "../../../utils/messageFuncs";

class ApiFornecedoresListas extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token?: string;
  basePath = "listas/fornecedores";

  constructor(data?: any) {
    super();
    const auth = new StorageItems().get("authToken"); // busca sempre fresh
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data !== undefined) {
      this.data = data;
      this.config.data = data;
    }
  }

  // POST /listas/fornecedores/create
  create = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/create`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((r) => r.data)
      .catch((error) => {
        try {
          return error.response.data;
        } catch {
          this.result.message = [
            generateMessageReturn(
              "Erro: Listas de fornecedores",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  // GET /listas/fornecedores/list  (aceita ?inativos=0|1)
  list = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/list`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((r) => r.data)
      .catch((error) => {
        try {
          return error.response.data;
        } catch {
          this.result.message = [
            generateMessageReturn(
              "Erro: Listas de fornecedores",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  // GET /listas/fornecedores/:id
  getOne = async (id: string | number) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/${id}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((r) => r.data)
      .catch((error) => {
        try {
          return error.response.data;
        } catch {
          this.result.message = [
            generateMessageReturn(
              "Erro: Buscar lista de fornecedores",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  // PUT /listas/fornecedores/update/:id
  // ATENÇÃO: controller lê req.body.data, então envie { data: payload }
  update = async (id: string | number) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/update/${id}`;
    this.config.method = "put";

    this.result = await axios(this.config)
      .then((r) => r.data)
      .catch((error) => {
        try {
          return error.response.data;
        } catch {
          this.result.message = [
            generateMessageReturn(
              "Erro: Atualização de listas de fornecedores",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  // DELETE /listas/fornecedores/delete/:id
  delete = async (id: string | number) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/delete/${id}`;
    this.config.method = "delete";

    this.result = await axios(this.config)
      .then((r) => r.data)
      .catch((error) => {
        try {
          return error.response.data;
        } catch {
          this.result.message = [
            generateMessageReturn(
              "Erro: Remoção de lista de fornecedores",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  // POST /listas/fornecedores/:id/itens/add  body: { id_fornecedores: number[] }
  addItens = async (id: string | number, id_fornecedores: number[]) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/${id}/itens/add`;
    this.config.method = "post";
    this.config.data = { id_fornecedores }; // controller lê direto do body

    this.result = await axios(this.config)
      .then((r) => r.data)
      .catch((error) => {
        try {
          return error.response.data;
        } catch {
          this.result.message = [
            generateMessageReturn(
              "Erro: Adicionar fornecedores na lista",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  // DELETE /listas/fornecedores/:id/itens/:id_item
  removeItem = async (id: string | number, id_item: string | number) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/${id}/itens/${id_item}`;
    this.config.method = "delete";

    this.result = await axios(this.config)
      .then((r) => r.data)
      .catch((error) => {
        try {
          return error.response.data;
        } catch {
          this.result.message = [
            generateMessageReturn(
              "Erro: Remover item da lista",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiFornecedoresListas;
